import {Component} from "react";

class SidebarHeader extends Component {

    render() {
        return null;
    }
}

export default SidebarHeader;
